import {
  setLadas, setTiposDeVialidades, setMonedas, setEstadosGlobales,
} from 'store/catalogos';
import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURL = '/catalogos';

/**
 * GET Content Types URs
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContentTypesUR = async (params) => {
  try {
    const response = await API.get(`${baseURL}/content-types-ur`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Codigo Postal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCodigoPostal = async (id) => {
  try {
    const response = await API.get(`/catalogos/codigos-postales/${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Codigos Postales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCodigosPostales = async (params) => {
  try {
    const response = await API.get('/catalogos/codigos-postales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Colonias
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getColonias = async (params) => {
  try {
    const response = await API.get('/catalogos/codigos-postales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Estados
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getEstados = async (params) => {
  try {
    const response = await API.get('/catalogos/estados/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Municipios
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getMunicipios = async (params) => {
  try {
    const response = await API.get('/catalogos/municipios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Municipio
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getMunicipio = async (id) => {
  try {
    const response = await API.get(`${'/catalogos/municipios'}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Tipos de Vialidades
 * @returns {Promise<object[]>}
 */
export const getTiposDeVialidades = async (dispatch = null, tiposVialidades = []) => {
  try {
    if (tiposVialidades.length) {
      return tiposVialidades;
    }
    const response = await API.get('/catalogos/tipos-de-vialidad/');
    if (dispatch) {
      dispatch(setTiposDeVialidades(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Metodos de Pago
 * @returns {Promise<object[]>}
 */
export const getMetodosDePago = async (dispatch, metodosDePago) => {
  try {
    if (metodosDePago?.length) {
      return metodosDePago;
    }
    const response = await API.get('/catalogos/metodos-de-pago/');
    if (dispatch) {
      dispatch(setTiposDeVialidades(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Ladas
 * @returns {Promise<object[]>}
 */
export const getLadas = async (dispatch, ladas = []) => {
  try {
    if (ladas.length) {
      return ladas;
    }
    const response = await API.get('/catalogos/ladas/');
    if (dispatch) {
      dispatch(setLadas(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Monedas
 * @returns {Promise<object[]>}
 */
export const getMonedas = async (dispatch, monedas = []) => {
  try {
    if (monedas.length) {
      return monedas;
    }
    const response = await API.get('/catalogos/monedas/');
    if (dispatch) {
      dispatch(setMonedas(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Estados Globales
 * @returns {Promise<object[]>}
 */
export const getEstadosGlobales = async (dispatch, estadosGlobales = []) => {
  try {
    if (estadosGlobales.length) {
      return estadosGlobales;
    }
    const response = await API.get('/catalogos/estados-globales/');
    if (dispatch) {
      dispatch(setEstadosGlobales(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Contratacion
 * @returns {Promise<object[]>}
 */
export const getTiposDeContratacion = async () => {
  try {
    const response = await API.get('/catalogos/tipo-de-contratacion');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Contratacion
 * @returns {Promise<object[]>}
 */
export const getClasificacionDeCuentaContable = async () => {
  try {
    const response = await API.get('/clasificaciones-de-cuentas-contables/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Fuentes de Financiamiento
 * @returns {Promise<object[]>}
 */
export const getFuentesDeFinanciamiento = async () => {
  try {
    const response = await API.get('/catalogos/clasificaciones-de-fuentes-de-financiamiento');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Fuentes de Financiamiento Contabilidad
 * @returns {Promise<object[]>}
 */
export const getFuentesDeFinanciamientoContabilidad = async () => {
  try {
    const response = await API.get('contabilidad/clasificaciones-de-fuentes-de-financiamiento/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Clasificaiones Administrativas
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getClasificacionesAdministrativas = async (params) => {
  try {
    const response = await API.get('/catalogos/clasificaciones-administrativas/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Nomina
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getTiposDeNomina = async (params) => {
  try {
    const response = await API.get('/catalogos/tipo-de-nomina/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodos
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getPeriodos = async (params) => {
  try {
    const response = await API.get('/catalogos/periodos', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Areas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAreas = async (params) => {
  try {
    const response = await API.get('/catalogos/directorio-de-areas', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dias de la Semana
* @param {object} params
* @returns {Promise<object[]>}
*/
export const getSemana = async () => {
  try {
    const response = await API.get('/catalogos/dias-de-la-semana');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Meses
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getMeses = async (params) => {
  try {
    const response = await API.get('/catalogos/meses/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET COGS
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getCOGS = async (params) => {
  try {
    const response = await API.get('/catalogos/clasificaciones-objeto-gasto/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET COGS Clasificadores por Objetos Del Gasto
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getClasificadoresObjetosGasto = async (params) => {
  try {
    const response = await API.get('/contabilidad/clasificaciones-objeto-gasto/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Gasto
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getTipoDeGasto = async (params) => {
  try {
    const response = await API.get('/catalogos/clasificaciones-tipo-de-gasto/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Gasto
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoGasto = async (id) => {
  try {
    const response = await API.get(`/catalogos/clasificaciones-tipo-de-gasto/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET COGS
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getCuentasContables = async (params) => {
  try {
    const response = await API.get('/contabilidad/cuentas-contables/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodicidades de Pagos
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getPeriodicidadesDePagos = async (params) => {
  try {
    const response = await API.get('/catalogos/periodicidades-de-pago/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Acreedores
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getAcreedores = async (params) => {
  try {
    const response = await API.get('/configuraciones/acreedores/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Deduccion de Nomina
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getTipoDeduccionDeNomina = async (params) => {
  try {
    const response = await API.get('/catalogos/tipo-de-deduccion-de-nomina/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Empleado
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getTiposDeEmpleados = async (params) => {
  try {
    const response = await API.get('/catalogos/tipo-de-empleado/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET Tipo de Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeEmpleado = async (id) => {
  try {
    const response = await API.get(`/catalogos/tipo-de-empleado/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Riesgo de Puesto
 * @param {object} paramas
 * @returns {Promise<object[]>}
 */
export const getRiesgosDePuestos = async (params) => {
  try {
    const response = await API.get('/catalogos/riesgo-de-puesto-de-nomina/', params);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
